(ns measure.report-schedule-table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium GridActionsCellItem]]
            ["src/svg/wpp/content-actions/edit.svg$default" :as Edit]
            ["src/svg/wpp/content-actions/trash.svg$default" :as Trash]
            ["src/svg/wpp/files/add-document.svg$default" :as AddDocument]
            [cljs-bean.core :refer [->js]]
            [common.flags :refer [use-flag]]
            [common.modal.dialog :refer [deletion-confirmation]]
            [common.modal.view :refer [defmodal]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.adset :as adset-queries]
            [common.resource.query.user :as user-queries]
            [common.util :as util]
            [common.widgets.data-grid :as dg]
            [mate.core :as mc]
            [measure.queries :as q]
            [measure.report-builder.context :as report-builder.ctx]
            [measure.report-builder.core :refer [->adset-ids entity-names]]
            [measure.report-table.view :refer [created-by-filter-options format-adset]]
            [measure.reporting-ocp.db.options :refer [date-phrase-options]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def entity-name
  (:report-schedule entity-names))

(defn date-phrase->label
  [date-phrase]
  (-> (filter #(= (:value %) date-phrase) date-phrase-options)
      first
      :label))

(defmodal confirm-delete :report-schedule/confirm-delete
  [{:keys [on-confirm]}]
  [deletion-confirmation
   {:on-submit on-confirm
    :entity-name entity-name}])

(defn columns [{:keys [created-by-options edit-report-schedule delete-report-schedule report-from-schedule]}]
  #js [#js {:field "name"
            :headerName "Name"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:name row))
            :flex 2}
       #js {:field "adsets"
            :headerName "Adsets"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:adsets row))
            :renderCell (fn [^js params]
                          (let [value (.-value params)]
                            ($ format-adset {:adsets value})))
            :flex 2}
       #js {:field "dateRange"
            :headerName "Date range"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:date-phrase row))
            :renderCell (fn [^js params]
                          (let [value (.-value params)]
                            (date-phrase->label value)))
            :flex 1}
       #js {:field "createdBy"
            :headerName "Created by"
            :type "singleSelect"
            :valueOptions created-by-options
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:user-id row))
            :renderCell (fn [^js params]
                          (let [row (.-row params)]
                            (or (:user-name row) "")))
            :flex 1}
       #js {:field "createdAt"
            :headerName "Created at"
            :type "dateTime"
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (js/Date. (:created-at row)))
            :renderCell (fn [^js params]
                          (let [value (.-value params)]
                            (util/format-iso-string value)))
            :flex 1}
       #js {:field "actions"
            :headerName "Actions"
            :type "actions"
            :cellClassName "hover-action-cell"
            :getActions (fn [^js params]
                          (let [row (.-row params)]
                            #js [($ GridActionsCellItem
                                    {:label (str "Generate " (:report entity-names))
                                     :icon ($ AddDocument)
                                     :onClick #(report-from-schedule row)
                                     :showInMenu true})
                                 ($ GridActionsCellItem
                                    {:label (str "Edit " entity-name)
                                     :icon ($ Edit)
                                     :onClick #(edit-report-schedule row)
                                     :showInMenu true})
                                 ($ GridActionsCellItem
                                    {:label (str "Delete " entity-name)
                                     :icon ($ Trash)
                                     :onClick #(rf/dispatch [:modal/open
                                                             {:id :report-schedule/confirm-delete
                                                              :props {:on-confirm (fn []
                                                                                    (delete-report-schedule {:id (:id row)}))}}])
                                     :showInMenu true})]))
            :flex 0}])

(defn get-row-id [row]
  (:id row))

(def Toolbar
  (uix/as-react
   (fn [{:keys [on-create]}]
     ($ dg/grid-toolbar
        {:hide-quick-filter true
         :sx #js {:justifyContent "flex-end"}}
        ($ Button
           {:onClick on-create
            :variant "contained"}
           (str "Create " entity-name))))))

(defui table []
  (let [{:keys [agency-id advertiser-id] :as url-context} (use-subscribe [:url-context])
        {users :data} (use-query (user-queries/users-query {:agency-id agency-id}))
        {adsets :data} (use-query (adset-queries/adsets-query {:advertiser-id advertiser-id}))

        adset-id->channel (uix/use-memo (fn []
                                          (mc/index-by :id :channel adsets))
                                        [adsets])

        unified-reporting-enabled? (use-flag :unified-reporting)
        {:keys [open-report-builder]} (report-builder.ctx/use-report-builder-context)

        edit-report-schedule (uix/use-callback
                              (fn [report-schedule]
                                (let [channel (adset-id->channel (first (->adset-ids report-schedule)))
                                      unified-report? (= (:type report-schedule) "report")]
                                  (if unified-report?
                                    (open-report-builder {:entity :report-schedule
                                                          :mode :edit
                                                          :initial-value (assoc report-schedule :channel channel)})
                                    (rf/dispatch [:form.report/open
                                                  {:entity :report-schedule
                                                   :initial-value (assoc report-schedule :adset-channel channel)}]))))
                              [adset-id->channel open-report-builder])

        on-row-click (uix/use-callback
                      (fn [^js params]
                        (edit-report-schedule (.-row params)))
                      [edit-report-schedule])

        {:keys [data isFetching]} (use-query (q/report-schedules-query {:advertiser-id advertiser-id}))

        rows (uix/use-memo (fn []
                             (q/enrich-reports data adsets users))
                           [data adsets users])

        created-by-options (uix/use-memo (fn []
                                           (created-by-filter-options rows))
                                         [rows])

        {delete-report-schedule :mutate} (use-mutation (q/delete-report-schedule-mutation url-context))
        {report-from-schedule :mutate} (use-mutation (q/report-from-schedule-mutation url-context))

        on-create (uix/use-callback
                   (fn []
                     (if unified-reporting-enabled?
                       (open-report-builder {:entity :report-schedule
                                             :mode :create})
                       (rf/dispatch [:form.report/open {:entity :report-schedule}])))
                   [unified-reporting-enabled? open-report-builder])]
    ($ DataGridPremium
       {:columns (columns {:created-by-options created-by-options
                           :edit-report-schedule edit-report-schedule
                           :delete-report-schedule delete-report-schedule
                           :report-from-schedule report-from-schedule})

        :loading isFetching

        :rows (to-array rows)
        :getRowId get-row-id
        :onRowClick on-row-click

        :checkboxSelection false
        :disableRowSelectionOnClick true

        :pagination true
        :pageSizeOptions #js [10]

        :initialState #js {:pagination #js {:paginationModel #js {:pageSize 10}}
                           :sorting #js {:sortModel #js [#js {:field "createdAt" :sort "desc"}]}}
        :slots #js {:toolbar Toolbar}
        :slotProps #js {:toolbar #js {:on-create on-create}
                        :filterPanel #js {:data-testid "filterPanel"
                                          :filterFormProps #js {:data-testid "filterForm"
                                                                :columnInputProps #js {:data-testid "columnInput"}
                                                                :operatorInputProps #js {:data-testid "operatorInput"}
                                                                :valueInputProps #js {:data-testid "valueInput"}}}}
        :sx (util/spread-obj #js {:maxHeight "70rem"
                                  "& .MuiDataGrid-row:hover" #js {:cursor "pointer"}}
                             (->js dg/hover-action-sx))})))
